export default function autoSubmit() {
    const forms = document.querySelectorAll('.fndry-query form');
    if (!forms) {
        return;
    }

    forms.forEach((form) => {
        const selects = form.querySelectorAll('select');
        if (!selects) {
            return;
        }
        selects.forEach((el) => {
            el.addEventListener('input', () => form.submit())
            el.parentElement.querySelector('.fndry-form-ctrl__reset')?.addEventListener('click', (e) => {
                el.dispatchEvent(new Event('input'));
            })
        })

    } )
}
